import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-462ac96d"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "page-container"
};
var _hoisted_2 = {
  class: "page-inner-container"
};
var _hoisted_3 = {
  class: "list-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ContestTabs = _resolveComponent("ContestTabs");
  var _component_ContestTable = _resolveComponent("ContestTable");
  var _component_a_empty = _resolveComponent("a-empty");
  var _component_a_spin = _resolveComponent("a-spin");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_spin, {
    size: "large",
    tip: "正在加载数据中...",
    spinning: _ctx.userExamService.loading,
    delay: 120
  }, {
    default: _withCtx(function () {
      var _a;
      return [_createVNode(_component_ContestTabs), _createElementVNode("div", _hoisted_3, [((_a = _ctx.userExamService.userExamList) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (_openBlock(), _createBlock(_component_ContestTable, {
        key: 0,
        list: _ctx.userExamService.userExamList
      }, null, 8, ["list"])) : _ctx.userExamService.total >= 0 ? (_openBlock(), _createBlock(_component_a_empty, {
        key: "key-empty",
        description: "暂无数据",
        style: {
          "margin": "100px 0",
          "font-size": "14px",
          "color": "#8f96a3"
        },
        image: _ctx.emptyImage,
        imageStyle: {
          height: '185px'
        }
      }, null, 8, ["image"])) : _createCommentVNode("", true)])];
    }),
    _: 1
  }, 8, ["spinning"])])]);
}